import { useMemo } from 'react';
import { sortArrayByLabel } from '@srcDS/components/organisms/productActions/utils/sortOrder';

interface Image {
  url: string;
  label?: string;
}

interface Variant {
  images?: Image[];
}

interface Attributes {
  productvideourl?: string;
  [key: string]: any;
}

interface ProductImage {
  id: string;
  url?: string;
  videoUrl?: string;
  thumbUrl?: string;
}

interface UseProductImagesProps {
  selectedVariant?: Variant;
  attributes?: Attributes;
  isContainThumbUrl?: boolean;
}

interface UseProductImagesResult {
  sortedImages: Image[];
  productImages: ProductImage[];
}

export const useProductImages = ({
  selectedVariant,
  attributes,
  isContainThumbUrl = false,
}: UseProductImagesProps): UseProductImagesResult => {
  const sortedImages = useMemo(() => {
    if (!selectedVariant?.images) return [];

    return sortArrayByLabel(Array.from(selectedVariant.images));
  }, [selectedVariant]);

  const productImages = useMemo(() => {
    const images: ProductImage[] = [];

    if (attributes?.productvideourl) {
      const videoImage: ProductImage = {
        id: attributes.productvideourl,
        videoUrl: attributes.productvideourl,
      };

      if (isContainThumbUrl && sortedImages?.[0]?.url) {
        {/*@ts-ignore*/}
        videoImage.thumbUrl = sortedImages[0].url;
      }

      images.push(videoImage);
    }

    if (sortedImages?.length) {
      sortedImages.forEach((image, index) => {
        images.push({
          id: `sortedImages_${image.url}_${index}`,
          url: image.url,
        });
      });
    }

    return images;
  }, [sortedImages, attributes, isContainThumbUrl]);

  return {
    sortedImages,
    productImages,
  };
};
